import React from "react";
import { formatCms } from "@/lib/richText";

/**
 * Renders a value that may be either JSX (code default) or a CMS string
 * with our minimal markdown. Safe: formatCms escapes HTML first.
 */
export default function RichText({ value, as: Tag = "span", className = "" }) {
  if (value == null || value === "") return null;
  if (typeof value !== "string") {
    // React element / fragment — render as-is
    return <Tag className={className}>{value}</Tag>;
  }
  return (
    <Tag
      className={className}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: formatCms(value) }}
    />
  );
}
